// extracted by mini-css-extract-plugin
export default {"1200":"(min-width: 1200px)","root":"sBXzsjxEk1HEXwLJ73Rr","content":"m5Sh_lpcsIrGrXjUky7y"};